var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lfs-logout"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"#2D9CDB","size":"26","width":"3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }